import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class CustomerService {
    static getCustomers(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        // return BaseService.getPaginated<IPortalUserDTO[]>(`portal-users`, pageNumber);
        return lastValueFrom(BaseService.getPaginated(`customers?filter=${qs}`, pageNumber));
    }
    static fetchCustomer(oid) {
        return lastValueFrom(BaseService.get(`customers/${oid}`));
    }
    static saveCustomer(dto) {
        return lastValueFrom(BaseService.save(`customers`, dto));
    }
    static deleteCustomer(oid) {
        return lastValueFrom(BaseService.delete(`customers/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Customer Quick Create
    // ----------------------------------------------------------------------
    static quickCreateCustomer(dto) {
        return lastValueFrom(BaseService.post(`customer-quick-create`, dto));
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchCustomerAllCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-all-search-dropdown/${selfId}?search=${qs}`));
    }
    static searchCustomerCustomersCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-customers-search-dropdown/${selfId}?search=${qs}`));
    }
    static searchCustomerSuppliersCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-suppliers-search-dropdown/${selfId}?search=${qs}`));
    }
    static searchCustomerCarriersCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-carriers-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Customer Addresses
    // ----------------------------------------------------------------------
    static getCustomerAddresses(customerId) {
        return lastValueFrom(BaseService.get(`customer-addresses/${customerId}`));
    }
    static saveCustomerAddress(dto) {
        return lastValueFrom(BaseService.save(`customer-addresses`, dto));
    }
    static deleteCustomerAddress(oid) {
        return lastValueFrom(BaseService.delete(`customer-addresses/${oid}`));
    }
    static searchCustomerAddressCombo(customerId, selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-address-search-dropdown/${customerId}/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Customer Cod317
    // ----------------------------------------------------------------------
    static getCustomerCod317(customerId) {
        return lastValueFrom(BaseService.get(`customer-cod317/${customerId}`));
    }
    static saveCustomerCod317(dto) {
        return lastValueFrom(BaseService.save(`customer-cod317`, dto));
    }
    static deleteCustomerCod317(oid) {
        return lastValueFrom(BaseService.delete(`customer-cod317/${oid}`));
    }
    static searchCustomerCod317Combo(customerId, selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-cod317-search-dropdown/${customerId}/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Customer Logotype
    // ----------------------------------------------------------------------
    static getCustomerLogotypes(customerId) {
        return lastValueFrom(BaseService.get(`customer-logotypes/${customerId}`));
    }
    static downloadCustomerLogotype(oid) {
        BaseService.downloadFile(`customer-logotype/${oid}`, null, null);
    }
    static uploadCustomerLogotype(customerId, file) {
        return lastValueFrom(BaseService.uploadFile(`customer-logotype/${customerId}`, file));
    }
    static deleteCustomerLogotype(oid) {
        return lastValueFrom(BaseService.delete(`customer-logotype/${oid}`));
    }
    static searchCustomerLogotypeCombo(customerId, selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-logotype-search-dropdown/${customerId}/${selfId}?search=${qs}`));
    }
}
